import DisputesHeaderDark from "../Components/DisputesHeaderDark";
import { Container, Row, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
// import CasePdf from "../Components/CasePdf";
import DisputesFooter from "../Components/DisputesFooter";

const getFiles = async (casenumber, setFiles, setError) => {
  try {
    const folderSearchResponse = await axios.get(
      "https://www.googleapis.com/drive/v3/files",
      {
        params: {
          q: `name = '${casenumber}' and mimeType = 'application/vnd.google-apps.folder' and '1ff5JCYUYeBHZ_2q3iM8SL6vptJUQ7NPm' in parents`,
          key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
          fields: "files(id, name)",
          supportsAllDrives: true,
          includeItemsFromAllDrives: true,
        },
      }
    );

    const folders = folderSearchResponse.data.files;

    if (folders.length === 0) {
      throw new Error(`No folder found with name "${casenumber}"`);
    }

    const folderId = folders[0].id;

    let allFiles = [];
    let nextPageToken = null;

    do {
      const response = await axios.get(
        "https://www.googleapis.com/drive/v3/files",
        {
          params: {
            q: `'${folderId}' in parents`,
            key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
            fields: "files(id, name, webViewLink, mimeType), nextPageToken",
            supportsAllDrives: true,
            includeItemsFromAllDrives: true,
            pageSize: 1000,
            pageToken: nextPageToken,
          },
        }
      );

      allFiles = [...allFiles, ...response.data.files];
      nextPageToken = response.data.nextPageToken || null;
    } while (nextPageToken);

    setFiles(allFiles);
  } catch (error) {
    console.error(
      "Error fetching case folder files:",
      error.response?.data || error.message
    );
  }
};

const getCase = async (caseid, setItem, setFiles) => {
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}cases/${caseid}/`
    );
    setItem(response.data);
    getFiles(response.data.casenumber, setFiles);
  } catch (error) {
    console.log(error);
  }
};

export default function CasePage() {
  const { caseid } = useParams();
  const [item, setItem] = useState(null);
  const [files, setFiles] = useState(null);

  useEffect(() => {
    getCase(caseid, setItem, setFiles);
  }, [caseid]);

  return (
    <>
      <DisputesHeaderDark />
      <div className="min-h-[100vh]">
        {item && (
          <>
            <section className="pt-[160px] lg:pt-[140px] pb-[50px] overflow-hidden lg:py-[100px] sm:py-[50px] sm:pt-[70px] md:py-[70px]  sm:h-[400px] xs:h-auto bg-dark">
              <Row className="justify-content-center">
                <Container className="row justify-content-center align-items-center pt-5">
                  <div className="col-4">
                    {" "}
                    <h5 className="text-[#ef8d23] font-bold text-center">
                      {item.complainant}
                    </h5>
                  </div>
                  <div className="col-1">
                    {" "}
                    <h5 className="text-[#ef8d23] font-bold text-center">
                      {" "}
                      vs.{" "}
                    </h5>
                  </div>
                  <div className="col-4">
                    {" "}
                    <h5 className="text-[#ef8d23] font-bold text-center">
                      {item.registrant}
                    </h5>
                  </div>
                </Container>
              </Row>
            </section>
            <Container>
              <Row className="justify-content-center mt-5">
                <div className="col-10">
                  <Table striped>
                    <tbody>
                      <tr>
                        <td>
                          {" "}
                          <p className="font-bold">Case Lodgement Date</p>
                          <p>{item.casedate}</p>
                        </td>
                        <td>
                          {" "}
                          <p className="font-bold">Case Number</p>
                          <p>{item.casenumber}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className="font-bold">Complainant</p>
                          <p>{item.complainant}</p>{" "}
                        </td>
                        <td>
                          {" "}
                          <p className="font-bold">Registrant</p>
                          <p>{item.registrant}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          {" "}
                          <p className="font-bold">Complainant Legal Council</p>
                          <p>{item.registrantlc ? item.complainantfirm.firm : "No legal council captured" }</p>
                        </td>
                        <td>
                          {" "}
                          <p className="font-bold">Registrant Legal Council</p>
                          <p>
                            {item.registrantlc
                              ? item.registrantfirm.firm
                              : "No legal council captured"}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <p className="font-bold">Domains</p>

                          {item.domains?.map((domain) => {
                            return (
                              <p>
                                {domain.domainname} - {domain.decisiontype2}
                              </p>
                            );
                          })}
                        </td>
                        {/* <td>
                          <p className="font-bold">Case Number</p>
                          <p>{item.casenumber}</p>
                        </td> */}
                      </tr>
                    </tbody>
                  </Table>
                  <div className="text-center mb-5 pb-5">
                    <h5 className="text-[#ef8d23] font-bold text-center mt-5">
                      Case Files
                    </h5>
                    {!files && <p>No files for this case yet</p>}
                    {files &&
                      files.map((file) => {
                        return (
                          <>
                            <Link
                              to={file.webViewLink}
                              target="_blank"
                              className="block my-3"
                            >
                              <i className="fas fa-file-pdf align-middle text-[32px] text-[#ef8d23] mr-2"></i>
                              {file.name}
                            </Link>
                          </>
                        );
                      })}
                  </div>
                </div>
              </Row>
            </Container>
          </>
        )}
      </div>

      <DisputesFooter
        theme="dark"
        className="text-[#828282] bg-darkgray consulting-footer"
      />
    </>
  );
}
